import { handleActions } from 'redux-actions';

import { resourceUpserters } from '../core';
import type { QcsSyncResourceStoreProps } from '../core/resourceStoreTypes';
import * as actions from './projectsActions';
import { mkProjectsStore, type ProjectProps, type ProjectsStore } from './projectsTypes';

const reducer = handleActions<
  ProjectsStore,
  | ReturnType<typeof actions.getProject>
  | ReturnType<typeof actions.getProjectSuccess>
  | ReturnType<typeof actions.getProjectFailure>
  | ReturnType<typeof actions.createProjectSuccess>
  | ReturnType<typeof actions.createProject>
  | ReturnType<typeof actions.updateProject>
  | ReturnType<typeof actions.updateProjectSuccess>
  | ReturnType<typeof actions.deleteProject>
  | ReturnType<typeof actions.deleteProjectSuccess>
>(
  {
    [actions.getProject.type]: (state) => state.merge({ isLoading: true, error: undefined }),
    [actions.getProjectSuccess.type]: (state, { payload: data }) =>
      resourceUpserters.upsertResources<ProjectProps, QcsSyncResourceStoreProps<ProjectProps>>(state, data),
    [actions.getProjectFailure.type]: (state, { payload: error }) =>
      resourceUpserters.completeWithError<ProjectProps, QcsSyncResourceStoreProps<ProjectProps>>(state, error),

    [actions.createProject.type]: (state, { payload: data }) =>
      resourceUpserters.upsertResource<ProjectProps, QcsSyncResourceStoreProps<ProjectProps>>(state, data),
    [actions.createProjectSuccess.type]: (state, { payload: data }) =>
      resourceUpserters.upsertResource<ProjectProps, QcsSyncResourceStoreProps<ProjectProps>>(state, data),

    [actions.updateProject.type]: (state, { payload: data }) =>
      resourceUpserters.upsertResource<ProjectProps, QcsSyncResourceStoreProps<ProjectProps>>(state, data),
    [actions.updateProjectSuccess.type]: (state, { payload: data }) =>
      resourceUpserters.upsertResource<ProjectProps, QcsSyncResourceStoreProps<ProjectProps>>(state, data),

    [actions.deleteProject.type]: (state, { payload: data }) =>
      resourceUpserters.upsertResource<ProjectProps, QcsSyncResourceStoreProps<ProjectProps>>(state, data),
    [actions.deleteProjectSuccess.type]: (state, { payload: data }) =>
      resourceUpserters.upsertResource<ProjectProps, QcsSyncResourceStoreProps<ProjectProps>>(state, data),
  },
  mkProjectsStore(),
);

export default reducer;
